import { Injectable } from "@angular/core";
import { TabVerifier } from "./tab-verifier.service";

@Injectable({
  providedIn: 'root'
})
export class InstagramTabVerifier extends TabVerifier {

  isProduct() {
    return true;
  }

}
